import React from "react";
import { ReactComponent as Logo } from '../../assets/images/footer_logo.svg'
import { CONSTANTS } from "../../constants/Constants";


const Footer:React.FC = () => {
    return (

        
        <div className=" bg-[#0A3822] layout-container">
           <div className="grid grid-cols-12 py-6">
                <div className="col-span-12 md:col-span-5">
                    <Logo className="object-contain w-[180px] h-14" width={100} />
                    <div className="pl-0 md:pl-7 text-white text-[20px] font-medium">
                        <p>From Individual Specialists To</p>
                        <p>Full Scale Tech Team</p>
                        <p>Augmentation</p>
                    </div>
                </div>
                <div className="col-span-12 md:col-span-3 text-white pt-12 md:pt-4">
                    <h1 className="text-[24px]">Offices</h1>
                    <div className="flex flex-col gap-y-1 text-[13px] mt-2">
                        <p>Stockholm, Sweden</p>
                        <p>Karachi & Lahore, Pakistan</p>
                        <p>Dubai, UAE</p>
                    </div>
                </div>
                <div className="col-span-12 md:col-span-4 text-white pt-12 md:pt-4">
                    <h1 className="text-[24px]">Contact</h1>
                    <div className="flex flex-col gap-y-1 text-[13px] mt-2">
                        <p>T:  +46 70 4420611</p>
                        <p>E: <a href="mailto:business@diyainteractive.com" className="text-[#23FF9C] underline">business@diyainteractive.com</a></p>
                    </div>
                </div>
           </div>
           <div className="pl-0 md:pl-7 mt-8 md:mt-14">
                <hr className="border-1 border-[#23FF9C] rounded-md mb-2" />
                <span className="text-white text-[12px]">{CONSTANTS.COPY_RIGHT_FOOTER_TXT}</span>
           </div>
        </div>

        
    )
}

export default Footer